import { useEffect } from 'react';
import useProgressStore from '../store/ProgressStore';

const useProgress = (progress: number): void => {
  const { setProgress } = useProgressStore();

  useEffect(() => {
    setProgress(progress);
  }, [progress, setProgress]);
};

export default useProgress;
